import moment from 'moment';
import React, { useState } from 'react';
import CloseIcon from '../../../../assets/icons/close.svg';
import { AuthenticatedPUTRequest, isEmptyObject } from '../../../../utils';

const EditPersonalDetails = (props) => {
    const { data, isStudent, setState, onError, onClose } = props;
    const [loading, setLoading] = useState(false);
    const bloodGroups = ['+A', '-A', '+B', '-B', '+O', '-O', '+AB', '-AB'];
    const [personalInformation, setPersonalInformation] = useState(data);

    const onSubmit = async (id, updatedInformation) => {
        const { data, success } = await AuthenticatedPUTRequest(
            isStudent ? `students/${id}` : `applicants/${id}`,
            updatedInformation,
        );
        setLoading(false);
        onClose();
        if (!success) {
            onError('براہ کرم دوبارہ کوشش کریں۔');
        } else {
            setState(data);
        }
    };

    console.log(
        moment(personalInformation['date_of_admission'], 'YYYY-MM-DD').format('YYYY-MM-DD'),
    );
    console.log(moment(personalInformation['date_of_birth'], 'YYYY-MM-DD').format('YYYY-MM-DD'));

    const onUpdate = () => {
        setLoading(true);
        var updatedInformation = {};
        for (let key in personalInformation) {
            if (key !== 'branch' && key !== 'class_room') {
                if (personalInformation[key] !== data[key]) {
                    updatedInformation[key] = personalInformation[key];
                }
            }
        }
        if (!isEmptyObject(updatedInformation)) {
            onSubmit(personalInformation.id, updatedInformation);
        } else {
            setLoading(false);
            onClose();
        }
    };

    return (
        <div
            className='flex column justifyCenter alignCenter'
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1000,
                background: 'rgba(0,0,0,0.7)',
            }}
        >
            <div
                style={{
                    background: '#ffffff',
                    height: 520,
                    maxHeight: 520,
                    width: 1100,
                    borderRadius: 8,
                }}
            >
                <div className='h-100 w-100' style={{ overflow: 'auto', position: 'relative' }}>
                    <div
                        className='flex justifyBetween alignCenter w-100'
                        style={{
                            borderBottom: '1px solid #E0E0E0',
                            padding: '20px 16px 8px',
                            height: 72,
                        }}
                    >
                        <h2 className='flex alignCenter w-100' style={{ color: '#009688' }}>
                            ذاتی معلومات ترمیم کریں
                        </h2>

                        <img
                            src={CloseIcon}
                            alt='close_icon'
                            height={32}
                            width={32}
                            onClick={props.onClose}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>

                    <div
                        className='flex column justifyCenter alignCenter urdu'
                        style={{ padding: 20 }}
                    >
                        <div className='flex column w-100'>
                            <div className='flex justifyBetween alignEnd'>
                                {/* name */}
                                <div className='form-container urdu'>
                                    <label htmlFor='name'>
                                        امیدوار کا نام
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='name'
                                        value={personalInformation['name']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    name: e.target.value,
                                                });
                                            } else {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    name: '',
                                                });
                                            }
                                        }}
                                    />
                                </div>
                                {/* D.O.B */}
                                <div className='form-container urdu'>
                                    <label htmlFor='date_of_birth'>
                                        امیدوار کی تاریخ پیدائش
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <input
                                        type='date'
                                        name='date_of_birth'
                                        value={moment(
                                            personalInformation['date_of_birth'],
                                            'YYYY-MM-DD',
                                        ).format('YYYY-MM-DD')}
                                        style={{
                                            height: 44,
                                            fontSize: 18,
                                            padding: 4,
                                            fontFamily: 'CircularStd',
                                        }}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    date_of_birth: e.target.value,
                                                });
                                            } else {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    date_of_birth: '',
                                                });
                                            }
                                        }}
                                    />
                                </div>
                                {/* cnic */}
                                <div className='form-container urdu'>
                                    <label htmlFor='cnic'>
                                        امیدوار کا شناختی کارڈ
                                        <span className='redText'>یا </span>ب فارم نمبر
                                        <span className='required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='cnic'
                                        value={personalInformation['cnic']}
                                        placeholder='xxxxxxxxxxxxx'
                                        maxLength={13}
                                        style={{
                                            height: 44,
                                            fontSize: 18,
                                            padding: 4,
                                            fontFamily: 'CircularStd',
                                        }}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    cnic: e.target.value,
                                                });
                                            } else {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    cnic: '',
                                                });
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className='flex justifyBetween alignEnd'>
                                {/* father name */}
                                <div className='form-container urdu'>
                                    <label htmlFor='father_name'>
                                        امیدوار کے والد کا نام
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='father_name'
                                        value={personalInformation['father_name']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    father_name: e.target.value,
                                                });
                                            } else {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    father_name: '',
                                                });
                                            }
                                        }}
                                    />
                                </div>
                                {/* Application submitting date  */}
                                <div className='form-container urdu'>
                                    <label htmlFor='date_of_admission'>
                                        تاریخ داخلہ میں آج کی تاریخ کا انتخاب کرے
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <input
                                        type='date'
                                        name='date_of_admission'
                                        value={moment(
                                            personalInformation['date_of_admission'],
                                            'YYYY-MM-DD',
                                        ).format('YYYY-MM-DD')}
                                        style={{
                                            height: 44,
                                            fontSize: 18,
                                            padding: 4,
                                            fontFamily: 'CircularStd',
                                        }}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    date_of_admission: e.target.value,
                                                });
                                            } else {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    date_of_admission: '',
                                                });
                                            }
                                        }}
                                    />
                                </div>
                                {/* father cnic */}
                                <div className='form-container urdu'>
                                    <label htmlFor='father_cnic'>
                                        والد کا شناختی کارڈ نمبر
                                        <span className='required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='father_cnic'
                                        value={personalInformation['father_cnic']}
                                        placeholder='xxxxxxxxxxxxx'
                                        maxLength={13}
                                        style={{
                                            height: 44,
                                            fontSize: 18,
                                            padding: 4,
                                            fontFamily: 'CircularStd',
                                        }}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    father_cnic: e.target.value,
                                                });
                                            } else {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    father_cnic: '',
                                                });
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className='flex justifyBetween alignEnd'>
                                {/* primary phone number */}
                                <div className='form-container urdu'>
                                    <label htmlFor='primary_phone_number'>
                                        امیدوار کا موبائل نمبر
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='primary_phone_number'
                                        placeholder='03xxxxxxxxx'
                                        maxLength={11}
                                        value={personalInformation['primary_phone_number']}
                                        style={{
                                            height: 44,
                                            fontSize: 18,
                                            padding: 4,
                                            fontFamily: 'CircularStd',
                                        }}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    primary_phone_number: e.target.value,
                                                });
                                            } else {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    primary_phone_number: '',
                                                });
                                            }
                                        }}
                                    />
                                </div>
                                {/* secondary phone number */}
                                <div className='form-container urdu'>
                                    <label htmlFor='secondary_phone_number'>
                                        امیدوار کا دیگر موبائل نمبر
                                    </label>
                                    <input
                                        type='text'
                                        name='secondary_phone_number'
                                        placeholder='03xxxxxxxxx'
                                        maxLength={11}
                                        value={personalInformation['secondary_phone_number']}
                                        style={{
                                            height: 44,
                                            fontSize: 18,
                                            padding: 4,
                                            fontFamily: 'CircularStd',
                                        }}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    secondary_phone_number: e.target.value,
                                                });
                                            } else {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    secondary_phone_number: '',
                                                });
                                            }
                                        }}
                                    />
                                </div>
                                {/* blood group list */}
                                <div className='form-container urdu'>
                                    <label htmlFor='blood_group'> امیدوار کا خون گروپ</label>
                                    <select
                                        name='blood_group'
                                        style={{
                                            height: 44,
                                            fontSize: 18,
                                            padding: 4,
                                            fontFamily: 'CircularStd',
                                        }}
                                        defaultValue={personalInformation['blood_group']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    blood_group: e.target.value,
                                                });
                                            } else {
                                                setPersonalInformation({
                                                    ...personalInformation,
                                                    blood_group: '',
                                                });
                                            }
                                        }}
                                    >
                                        {bloodGroups.map((group, index) => (
                                            <option
                                                value={group}
                                                key={index + 1}
                                                defaultValue={
                                                    personalInformation['blood_group'] === group
                                                }
                                            >
                                                {group}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div
                            className='flex justifyEnd alignCenter w-100'
                            style={{ height: 64, marginTop: 16 }}
                        >
                            <div className='flex justifyBetween alignCenter'>
                                <div
                                    className='flex justifyEnd alignCenter register_button'
                                    style={{ margin: '0 8px' }}
                                    onClick={() => onUpdate()}
                                >
                                    {loading ? (
                                        <div className='custom_loader' />
                                    ) : (
                                        <h3>{`محفوظ کریں`}</h3>
                                    )}
                                </div>
                                <div
                                    className='flex justifyEnd alignCenter delete_button'
                                    style={{ margin: '0 8px' }}
                                    onClick={() => onClose()}
                                >
                                    <h3>{`منسوخ کریں`}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditPersonalDetails;
